import React from 'react'
import {
  createHashRouter,
} from "react-router-dom";

import { AuthenticationViews } from './Store'

import Authentication from './Authentication';
import ExternalLogin from './ExternalLoginContainer';
import ForgotPassword from './ForgotPasswordContainer';
import IdentifierCheck from './IdentifierCheckContainer';
import Join from './JoinContainer';
import KnownUserLogin from './KnownUserLoginContainer';
import Login from './LoginContainer';
import LoginPassword from './LoginPasswordContainer';
import ParticipantLanding from './ParticipantLanding';
import ResetPassword from './ResetPasswordContainer';
import SetPassword from './SetPasswordContainer';
import SplashScreen from './SplashScreen';
import VerifyEmail from './VerifyEmailContainer';
import VerifyEmailUpdate from './VerifyEmailUpdateContainer';
import VerifyNonce from './VerifyNonceContainer';
import VerifyPhone from './VerifyPhoneContainer';


const AuthenticationRouter = createHashRouter([
  {
    path: '/',
    element: <ParticipantLanding />,
  },
  {
    path: '/',
    element: <Authentication />,
    children: [
      {
        path: AuthenticationViews.identifierCheck,
        element: <IdentifierCheck />
      }, {
        path: AuthenticationViews.join,
        element: <Join />
      }, {
        path: AuthenticationViews.verifyPhone,
        element: <VerifyPhone />
      }, {
        path: AuthenticationViews.setPassword,
        element: <SetPassword />
      }, {
        path: AuthenticationViews.login,
        element: <Login />
      }, {
        path: AuthenticationViews.loginPassword,
        element: <LoginPassword />
      }, {
        path: AuthenticationViews.knownUserLogin,
        element: <KnownUserLogin />
      }, {
        path: AuthenticationViews.verifyNonce,
        element: <VerifyNonce />
      }, {
        path: AuthenticationViews.verifyEmail,
        element: <VerifyEmail />
      }, {
        path: AuthenticationViews.forgotPassword,
        element: <ForgotPassword />
      }, {
        path: AuthenticationViews.resetPassword,
        element: <ResetPassword />
      }, {
        path: AuthenticationViews.verifyEmailUpdate,
        element: <VerifyEmailUpdate />
      }, {
        path: AuthenticationViews.externalLogin,
        element: <ExternalLogin />
      }, {
        path: AuthenticationViews.splash,
        element: <SplashScreen />
      }, {
        path: '',
        element: <SplashScreen />
      }
    ]
  },
]);

export default AuthenticationRouter;